// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5956 ? "b27bed02" : chunkId) + "." + {"28":"3b64acf480254f88","2398":"aa2a1dde494a1b9b","3268":"2588b673148f136e","4529":"8071828f2b2d218a","5400":"08833f24ab225685","5956":"ceaf95ca5a860afc"}[chunkId] + ".js";
};